<script setup lang="ts">
import { ICON_PATHS } from '../icons'
import type { IconName } from '../types'

/**
 * 手写内联图标。
 *
 * 为什么不用 `<img src>` 或字体图标:图标要跟着文字的颜色走(选中态是白的、
 * 默认态是灰的),`currentColor` 一个字就解决了;换成图片或字体图标,
 * 要么引两个文件,要么在每个状态上写一份颜色。
 *
 * 尺寸默认 18,是因为它主要出现在侧边栏与按钮里 —— 那里视觉重量最合适。
 */
const props = withDefaults(defineProps<{ name: IconName; size?: number }>(), { size: 18 })
</script>

<template>
  <svg
    class="nav-icon"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.7"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path :d="ICON_PATHS[props.name]" />
  </svg>
</template>

<style scoped>
.nav-icon {
  display: block;
  flex: none;
}
</style>
